import type { Assignee } from '../types/assignee';

export const UNASSIGNED_TEXT = 'לא משויך';

/** כל שמות המשויכים, מופרדים בפסיק (ל-tooltip ולתצוגה מלאה). */
export const formatAllAssigneeNames = (assignees: Assignee[] | undefined): string =>
  assignees && assignees.length > 0
    ? assignees.map((a) => a.fullName || `#${a.userId}`).join(', ')
    : UNASSIGNED_TEXT;

/** תצוגה קומפקטית: עד maxNames שמות, והשאר כ-"+N" ("דנה כהן, יוסי לוי +2"). */
export const formatAssigneeNames = (assignees: Assignee[] | undefined, maxNames = 2): string => {
  if (!assignees || assignees.length === 0) return UNASSIGNED_TEXT;
  const names = assignees.map((a) => a.fullName || `#${a.userId}`);
  if (names.length <= maxNames) return names.join(', ');
  return `${names.slice(0, maxNames).join(', ')} +${names.length - maxNames}`;
};

/**
 * "המשויך הראשי" לצביעה ביומן: הראשון לפי סדר השיוך שעונה לסינון הנוכחי (עובד / מחלקה),
 * אחרת הראשון לפי סדר השיוך. מחזיר undefined לפריט ללא משויכים (תזכורת ממאגר המנהלים).
 */
export const getPrimaryAssignee = (
  assignees: Assignee[] | undefined,
  isPreferred?: (userId: number) => boolean
): Assignee | undefined => {
  if (!assignees || assignees.length === 0) return undefined;
  return (isPreferred && assignees.find((a) => isPreferred(a.userId))) || assignees[0];
};
